export default __webpack_public_path__ + "static/media/img_other12.6e8589bc.webp";